import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface BackToPageButtonProps {
  onClick: () => void;
  text?: string;
  variant?: "ghost" | "outline" | "secondary" | "default";
  size?: "sm" | "default" | "lg" | "icon";
  className?: string;
  showText?: boolean;
  iconClassName?: string;
}

export function BackToPageButton({ 
  onClick, 
  text = "Back to Jobs",
  variant = "ghost", 
  size = "sm",
  className = "font-medium",
  showText = true,
  iconClassName = "h-4 w-4 text-orange-600"
}: BackToPageButtonProps) {
  return (
    <Button
      variant={variant}
      size={size}
      onClick={onClick}
      className={className}
      data-testid="button-back-to-page"
    >
      <ArrowLeft className={`${iconClassName} ${showText ? 'mr-2' : ''}`} />
      {showText && text}
    </Button>
  );
}
